import { css } from "@emotion/react";

import { clearButtonDecoration } from "~/client/styles/emotion/mixins/clearButtonDecoration";
import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import { pointingDevice } from "~/client/styles/emotion/mixins/pointingDevice";
import tokens from "~/packages/design-tokens/dist/tokens";

export const itemLayoutCss = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:hover": {
    "button": {
      visibility: "visible",
    },
  },
});

export const contentCss = css({
  display: "grid",
  gridTemplate: "'icon . keywords . filters' auto / auto 8px auto 14px minmax(100px, 1fr)",
  alignItems: "center",
});

export const iconCss = css({
  gridArea: "icon",
  color: tokens.color.symbol.primary.default.value,
});

export const keywordsCss = css({
  gridArea: "keywords",
  wordBreak: "break-word",
});

export const filtersCss = css({
  gridArea: "filters",
  wordBreak: "break-word",
  color: tokens.color.text.tertiary.default.value,
  ...fontSize(13),
});

export const saveFilterSetButtonCss = css([
  {
    marginLeft: "10px",
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    color: tokens.color.text.tertiary.default.value,
  },
  clearButtonDecoration(),
  fontSize(12),
  pointingDevice({
    visibility: "hidden",
  }),
]);

export const deleteButtonCss = css([
  {
    display: "flex",
    alignItems: "center",
    height: "20px",
    marginLeft: "12px",
  },
  clearButtonDecoration(),
  fontSize(14),
  pointingDevice({
    visibility: "hidden",
  }),
]);

export const deleteIconCss = css({
  "&:hover": {
    fill: tokens.color.gray[700].value,
  },
});
